import React, {useState, useMemo} from 'react';
import _size from 'lodash/size';
import _get from 'lodash/get';
import _toLower from 'lodash/toLower';
import _reduce from 'lodash/reduce';
import _reject from 'lodash/reject';
import _find from 'lodash/find';
import _each from 'lodash/each';
import _filter from 'lodash/filter';
import _some from 'lodash/some';
import _every from 'lodash/every';
import _isEmpty from 'lodash/isEmpty';
import S from 'StyledBetHistoryTransactionItem.js';
import useToggle from 'UseToggle.js'
import ModalOpacity from 'ModalOpacity.js';
import {formatDate} from 'datesHelper.js';
import {translation, decimal} from 'utilsHelper.js'
import CashoutForm from 'CashoutForm.js';
import SlipDetailsArrow from 'arrow_slip_details.png';
import {withRouter} from 'react-router-dom';
import FreebetIcon from 'freebet_icon.svg';
import {getPolishTransactionType} from 'helpers/transactionsHelper.js';

const BetHistoryTransactionItem = ({
    transaction,
    currencyCode,
    cashouts,
    cashoutsMultiCoupon,
    prepareCashout,
    processCashout,
    refreshBetHistoryList,
    toggleLiveCurtainForTxId,
    history
}) => {
    const {
        transactionId,
        regDate,
        stake: transactionStake,
        possibleReturn: transactionPossibleReturn,
        confirmedReturn: transactionConfirmedReturn,
        statusCode: transactionStatusCode,
        bonus = 0,
        slipType,
        curtainActive = false,
        maxAmount = '',
        transactionDetails,
        cashBackReturn,
        totalOddsWithoutSalesTaxFactor,
        slipCombinations = null,
        isFreebet,
        multiCouponCombinationDetails
    } = transaction;

    const { 
        combinationId, 
        stake: combinationStake,
        possibleReturn: combinationPossibleReturn,
        confirmedReturn: combinationConfirmedReturn,
        status: combinationStatus,
    } = multiCouponCombinationDetails?.[0] ?? {};

    const stake = combinationStake ?? transactionStake;
    const possibleReturn = combinationPossibleReturn ?? transactionPossibleReturn;
    const confirmedReturn = combinationConfirmedReturn ?? transactionConfirmedReturn;
    const statusCode = combinationStatus ?? transactionStatusCode;

    const [showCashoutModal, toggleCashoutModal] = useToggle(false);
    const [showCashoutErrorModal, toggleCashoutErrorModal] = useToggle(false);
    const [cashoutErrorCode, setCashoutErrorCode] = useState('');

    const checkIfFof = () => {
        return transactionDetails.some(outcome => {
            const isOddsWithoutFof =
                outcome.oddsWithoutFof && outcome.oddsWithoutFof !== outcome.odds;
            return isOddsWithoutFof && outcome.fofFactor
        })
    };

    const hasFof = checkIfFof()
    const boostClass = app.config.highlightBoostedOdds && hasFof ? 'highlight-boost' : ''
    const highlightBoostedOdds = app.config.highlightBoostedOdds && hasFof && [0, 100, 1000].indexOf(slipType) != -1

    const getTransactionType = useMemo(() => {
        return getPolishTransactionType(transaction);
    }, []);

    const hasCancelledCombination = () => {
        return transactionDetails?.every(detail => detail.statusCode === 4) ?? false;
    };

    const getTransactionStatusClass = (statusCode, stake, confirmedReturn, pretty, cashBackReturn, isFreebet) => {

        if (cashBackReturn) {
            return 'cashback';
        }

        let resultText = '';
        const hasCancelledComb = hasCancelledCombination();

        if (statusCode == 2) {

            if ([0, 100].indexOf(slipType) != -1) {
                if ((confirmedReturn + bonus) >= stake || (isFreebet && confirmedReturn > 0) || (isFreebet && hasCancelledComb)) {
                    resultText = 'won';
                } else {
                    resultText = 'lost';
                }
            } else {
                if (confirmedReturn > 0) {
                    resultText = 'won';
                } else {
                    resultText = 'lost';
                }
            }

        } else {

            switch (statusCode) {
                case 0:
                    resultText = 'pending_acceptation';
                    break;
                case 1:
                    resultText = 'placed';
                    break;
                case 2 :
                    resultText = 'won';
                    break;
                case 3 :
                    resultText = 'lost';
                    break;
                case 4 :
                case 10 :
                    resultText = 'cancel';
                    break;
                case 5 :
                    resultText = 'cashout';
                    break;
            }
        }

        if (pretty && resultText) {
            resultText = resultText.substring(0, 1).toUpperCase() + resultText.substring(1, resultText.length);
        }

        return resultText;
    };

    const toggleCashout = async () => {
        try {
            await prepareCashout(transactionId, combinationId);
            toggleCashoutModal();
        } catch (errorCode) {
            setCashoutErrorCode(errorCode);
            toggleCashoutErrorModal();
        }
    };

    const openCashoutModal = (e) => {
        e.stopPropagation();
        toggleCashout();
    };

    const checkCashout = () => {
        if (combinationId) {
            const combinationCashout = cashoutsMultiCoupon[transactionId];
            return combinationCashout && combinationCashout.combinationIds.has(combinationId);
        }

        const multiCashoutAvailable = process.env.MULTI_CASHOUT_AVAILABLE && JSON.parse(process.env.MULTI_CASHOUT_AVAILABLE);
        if (multiCashoutAvailable) {
            return cashouts && (transactionId in cashouts) && getCashoutAmmountForTxId() !== null;
        }

        return (cashouts && cashouts.indexOf(transactionId) !== -1);
    };

    const getCashoutAmmountForTxId = () => {
        if (combinationId) {
            return cashoutsMultiCoupon[transactionId].amount;
        }

        return _get(cashouts, [transactionId, 'currentCashoutAmount']);
    };

    const goToTransactionDetails = () => {
        if (!transactionDetails) return
        history.push(`/bet-history/${transactionId}${combinationId ? `-${combinationId}` : ''}`);
    }

    const transactionStatusClass = getTransactionStatusClass(statusCode, stake, confirmedReturn, false, cashBackReturn, isFreebet);
    const transactionStatus = transactionStatusClass;
    const cashoutFormProps = {
        toggleLiveCurtainForTxId,
        curtainActive,
        refreshBetHistoryList,
        transactionId,
        stake,
        possibleReturn,
        maxAmount,
        toggleCashoutModal,
        toggleCashoutErrorModal,
        prepareCashout,
        currencyCode,
        cachoutOnSubmit: processCashout,
        initialValues: {maximumAmount: maxAmount},
        transactionOdds: decimal(totalOddsWithoutSalesTaxFactor),
        combinationId
    };

    const getCombinationApplicableBonusAmount = useMemo(() => {
        let combinationApplicableBonus = 0;
        if (slipCombinations?.combinations) {
            for (let combination of slipCombinations.combinations) {
                if (combination.confirmedReturn) {
                    combinationApplicableBonus = combinationApplicableBonus + combination.bonus;
                }
            }
        }
        return combinationApplicableBonus
    },[]);

    const getTransactionResult = useMemo(() => {
        let ammount = null;
        let translationKey = null;
        let isWon = false;
        let isCombinationWon = false;
        if (transactionStatus == 'won') {
            isWon = true;
            ammount = (isFreebet && hasCancelledCombination()) ? decimal(0) : (confirmedReturn > 0 ? decimal(confirmedReturn + bonus) : confirmedReturn);
            translationKey = translation('transactionDetails_betSlipWon');
        } else if ( transactionStatus == 'placed' && (confirmedReturn !== 0 || null) && !multiCouponCombinationDetails) {
            isCombinationWon = true;
            ammount = confirmedReturn > 0 ? decimal(confirmedReturn + getCombinationApplicableBonusAmount) : confirmedReturn;
            translationKey = translation('transactionDetails_CombinationWon');
        } else if (transactionStatus == 'cashout') {
            isWon = true;
            ammount = decimal(confirmedReturn);
            translationKey = translation('transactionDetails_betSlipCashout');
        } else if (transactionStatus == 'lost') {
            ammount = decimal(0);
            translationKey = translation('transactionDetails_betSlipLost');
        } else if (transactionStatus == 'cancel') {
            ammount = decimal(confirmedReturn);
            translationKey = translation('transactionDetails_betSlipCancel');
        } else if (transactionStatus == 'cashback') {
            ammount = decimal(cashBackReturn);
            translationKey = translation('transactionDetails_betSlipCashback');
        } else {
            return null;
        }

        return (
            <>
                <S.TransactionTitle>{translationKey}</S.TransactionTitle>
                <S.TransactionAmmount isWon={isWon} isCombinationWon={isCombinationWon}>{ammount} {currencyCode}</S.TransactionAmmount>
            </>
        )

    }, []);

    return (
        <S.BetHistoryItemWrapper className="bet-history-item-wrapper">

            <ModalOpacity isOpen={showCashoutModal} toggleOpen={toggleCashoutModal} showHeaderIcon={false} title="Cashout" padding={0} showHeader={false}>
                <CashoutForm {...cashoutFormProps}></CashoutForm>
            </ModalOpacity>

            <ModalOpacity isOpen={showCashoutErrorModal} toggleOpen={toggleCashoutErrorModal} showHeaderIcon={false} showHeaderTitle={false} padding="8px">
                <S.ErrorModal>
                    <S.ErrorModalTitle>{translation('account_betHistoryTransactionItem_cashout_error_title')}</S.ErrorModalTitle>
                    <S.ErrorModalMessage>{translation('account_betHistoryTransactionItem_cashout_error_' + cashoutErrorCode)}</S.ErrorModalMessage>
                </S.ErrorModal>
            </ModalOpacity>

            <S.BetHistoryItem className={`bet-history-item ${boostClass}`} onClick={goToTransactionDetails}>

                <div className={`transaction-status ${transactionStatusClass}`}></div>

                <div className="transaction-type">
                    <span>{getTransactionType}</span>
                </div>

                <div className={`transaction-amount${(process.env.CASHOUT) ? '-cashout' : ''}`}>
                    {decimal(stake)}&nbsp;{currencyCode}
                    {(process.env.ENABLE_FREEBET && isFreebet) &&
                    <S.FreebetIcon dangerouslySetInnerHTML={{__html: FreebetIcon}}/>}
                </div>

                <div className="transaction-odd">
                    {[0, 100, 1000].indexOf(slipType) != -1 ? 
                        <>
                            {decimal(totalOddsWithoutSalesTaxFactor)}
                            {highlightBoostedOdds ? <S.BoostOddsIcon /> : null}
                        </>
                    : null}
                </div>

                <div className="transaction-result">
                    {getTransactionResult}
                </div>

                {process.env.CASHOUT && (
                    <div className="transaction-cashout">
                        {(checkCashout() && !isFreebet) && (
                            <button onClick={openCashoutModal}>
                                {getCashoutAmmountForTxId()}&nbsp;{currencyCode}
                            </button>
                        )}
                    </div>
                )}

                <div className={`transaction-date${(process.env.CASHOUT) ? '-cashout' : ''}`}>
                    <span>{formatDate(regDate, 'dd-MM-yyyy')}</span>
                    <span>godz. {formatDate(regDate, 'HH:mm:ss')}</span>

                    <S.SlipDetailsArrow src={SlipDetailsArrow}/>
                </div>

            </S.BetHistoryItem>

        </S.BetHistoryItemWrapper>
    );
};

export default withRouter(BetHistoryTransactionItem);
